/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { formatMoney as formatMoneySarsa } from 'sarsaparilla';

const formatCurrency = (amount) => {
    return formatMoneySarsa(amount);
};

export default formatCurrency;
